"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDPCancel = exports.DDPError = exports.DDPClient = void 0;
/* eslint-disable consistent-default-export-name/default-export-match-filename */
const DDPClient_1 = __importDefault(require("./DDPClient"));
exports.DDPClient = DDPClient_1.default;
const errors_1 = require("./errors");
Object.defineProperty(exports, "DDPError", { enumerable: true, get: function () { return errors_1.DDPError; } });
Object.defineProperty(exports, "DDPCancel", { enumerable: true, get: function () { return errors_1.DDPCancel; } });
//# sourceMappingURL=index.js.map